// src/data/index.js
import { en_EN } from './section-templates-en_EN';
import { en_EN_the_prophet } from './section-templates-en_EN_the_prophet'
import { hi_HI_vyavhaar } from './section-templates-hi_Hamara_vyavhaar'
import { ur_UR_the_prophet } from './section-templates-ur_UR_the_prophet'


export const allSectionTemplates = {
  en_EN,
  en_EN_the_prophet,
  hi_HI_vyavhaar,
  ur_UR_the_prophet,
};

export const templateOptions = [
  { value: 'en_EN', label: 'English - Standard Book' },
  { value: 'en_EN_the_prophet', label: 'English - The Prophet Muhammad' },
  { value: 'hi_HI_vyavhaar', label: 'Hindi - Hamara Vyavhaar Book' },
  { value: 'ur_UR_the_prophet', label: 'Urdu - The Prophet Muhammad' },

].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
